export const filterAndSortImagesBySpread = (images, spreadImages) =>
  images
    .filter((image) => spreadImages.some((spreadImage) => spreadImage.id === image._id))
    .sort((a, b) => {
      const indexA = spreadImages.findIndex((img) => img.id === a._id);
      const indexB = spreadImages.findIndex((img) => img.id === b._id);

      return indexA - indexB;
    });
